import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito experiencia previa?',
    answer: 'No. Todo está explicado desde cero paso a paso. El curso está diseñado para principiantes absolutas que quieren convertirse en profesionales.'
  }, {
    question: '¿Cuánto debo invertir en productos?',
    answer: 'Puedes comenzar con un kit básico de menos de $2.000 y mejorar con lo que ganes. En el curso te enseñamos exactamente qué comprar para no desperdiciar dinero.'
  }, {
    question: '¿Cuánto puedo ganar?',
    answer: 'Desde $5.000 a $20.000 mensuales según tu ritmo y clientela. Algunas de nuestras alumnas superan estos montos al especializarse en técnicas premium.'
  }, {
    question: '¿Cuánto tiempo dura?',
    answer: 'Es autodidacta. Avanzas a tu ritmo. Puedes terminar en 2 a 4 semanas, aunque tendrás acceso de por vida para repasar cuando quieras.'
  }, {
    question: '¿El certificado es real?',
    answer: 'Sí. Firmado digitalmente y 100% verificable para redes o clientes. Puedes usarlo en tu perfil profesional y en tus redes sociales.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4" data-id="element-40">
      <div className="container mx-auto max-w-4xl" data-id="element-41">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-42">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, index) => <div key={index} className="border border-pink-200 rounded-lg overflow-hidden bg-white" data-id="element-44">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFAQ(index)} data-id="element-45">
                <span className="font-semibold text-lg" data-id="element-46">{faq.question}</span>
                {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-pink-500" data-id="element-47" /> : <ChevronDownIcon className="h-5 w-5 text-pink-500" data-id="element-48" />}
              </button>
              {openIndex === index && <div className="px-6 py-4 border-t border-pink-100 bg-pink-50" data-id="element-49">
                  <p className="text-gray-700" data-id="element-50">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}